// extracted by mini-css-extract-plugin
module.exports = {"table":"PopupShowHistory_table__1jqwc","title":"PopupShowHistory_title__2mESq","titleGradeAndSubject":"PopupShowHistory_titleGradeAndSubject__1T42T"};